const AuthFormFields = {
  shippingNo: {
    Name: 'shippingNo',
    label: 'Shipping account number',
    placeholder: 'Shipping account number',
    errorMsg: {
      required: 'Shipping Number is required',
      invalid: 'Shipping Number is invalid',
    },
  },
  username: {
    Name: 'username',
    label: 'Username',
    placeholder: 'Username',
    errorMsg: {
      required: 'Username is required',
      invalid: 'Username is invalid',
    },
  },
  password: {
    Name: 'password',
    label: 'Password',
    placeholder: 'Password',
    errorMsg: {
      required: 'Password is required',
      invalid: 'Password is invalid',
    },
  },
  keep: {
    Name: 'keep',
    label: 'Remember me',
  },
}

export default AuthFormFields
